import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

export const useEditorialCardSliderOptions = () => {
  const { desktop, tabletOnly } = useBreakpoints();

  return {
    spaceBetween: 24,
    slidesPerView: desktop ? 3 : tabletOnly ? 2.2 : 1.2,
  };
};
